import React from 'react';
import classNames from 'classnames';

import Button from 'components/designSystem/Button/Button';
import Grid from 'components/designSystem/Grid/Grid.tsx';

import SolutionCard from './SolutionCard/SolutionCard';

import marketplaceIcon from './mp-icon.svg';
import obnIcon from './order-better-network-icon.svg';
import directIcon from './od-icon.svg';

import styles from './RestaurantSolutions.module.scss';

const SOLUTION_CARDS = [
  {
    title: 'ChowNow App',
    header: 'Increase revenue with our commission-free app',
    body: 'Get orders on the only takeout app built for independent restaurants—with no commissions and zero hidden fees.',
    image: marketplaceIcon,
    link: 'https://get.chownow.com/marketplace?utm_source=marketplace_web&utm_medium=b2b_module_card',
  },
  {
    title: 'Order Better Network',
    header: "Promote your restaurant on the web's most popular sites",
    body: "Expand your reach beyond the typical apps. Get listed on some of the world's most popular sites to increase orders even more.",
    image: obnIcon,
    link: 'https://get.chownow.com/order-better-network?utm_source=marketplace_web&utm_medium=b2b_module_card',
  },
  {
    title: 'Pro',
    header: 'Power up your online presence with professional tools',
    body: 'Upgrade your online ordering with branded apps, marketing, integrations, and more—all customized for your restaurant.',
    image: directIcon,
    link: 'https://get.chownow.com/direct?utm_source=marketplace_web&utm_medium=b2b_module_card',
  },
];

export default function RestaurantSolutions() {
  return (
    <section className={styles.restaurantSolutions}>
      <div className={styles.solutionsWrapper}>
        <div className={styles.solutionsHeader}>
          <div className={styles.solutionsHeaderCopy}>
            <h2 className={styles.solutionHeadline}>ChowNow for restaurants </h2>
            <p className={styles.solutionsCopy}>
              We&apos;re helping 20,000+ restaurants grow beyond brick and mortar. With three
              products and endless possibilities, you can build a custom solution that&apos;s right
              for you.
            </p>
          </div>
          <Button
            onClick={() =>
              window.open(
                'https://get.chownow.com/?utm_source=marketplace_web&utm_medium=b2b_module_main_cta',
                '_blank'
              )
            }
            fullWidth
            className={classNames(styles.btnMobile, styles.solutionsButton)}
            variant="inverse"
          >
            See Restaurant Solutions
          </Button>
          <Button
            onClick={() =>
              window.open(
                'https://get.chownow.com/?utm_source=marketplace_web&utm_medium=b2b_module_main_cta',
                '_blank'
              )
            }
            fullWidth
            className={classNames(styles.btnDesktop, styles.solutionsButton)}
            variant="inverse"
            size="large"
          >
            See Restaurant Solutions
          </Button>
        </div>
        <Grid container className={styles.solutionsCardGrid}>
          {SOLUTION_CARDS.map((card) => (
            <Grid sm={4} md={4} lg={4} className={styles.cardWrap} key={card.title}>
              <SolutionCard
                title={card.title}
                key={card.header}
                header={card.header}
                body={card.body}
                image={card.image}
                link={card.link}
              />
            </Grid>
          ))}
        </Grid>
      </div>
    </section>
  );
}
